import styled, { css } from 'styled-components'
import BaseImage from 'components/Image'
import { breakpoint } from 'utils'

// using a custom token here as requested by design
export const ItemContainerColor = `RGBA(0, 0, 0, 0.02)`
// this is in rem, used for the xxl breakpoint
export const BIG_CONTAINER_WIDTH = 18
export const BIG_CONTAINER_HEIGHT = 12

export const ListGrid = styled.ul`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  flex-wrap: wrap;
  margin: 16px 4px 0 4px;
  padding: 0;
  gap: 24px;
  min-width: 300px;

  ${breakpoint('sm')`
    margin: 16px 24px 0 24px;
  `};
`

export const ListGridItem = styled.li`
  max-width: 200px;
  list-style: none;

  ${breakpoint('xxl')`
    max-width: ${BIG_CONTAINER_WIDTH}rem;
  `};
`

export const ItemImageWrapper = styled.div(
  ({ theme }) => css`
    background-color: ${ItemContainerColor};
    border-radius: ${theme.radii.large};
    width: 200px;
    height: 128px;
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    ${breakpoint('xxl')`
        width: ${BIG_CONTAINER_WIDTH}rem;
        height: ${BIG_CONTAINER_HEIGHT}rem
    `};
  `
)

export const ItemImage = styled(BaseImage)`
  min-width: 100px;
  min-height: 100px;
`

export const ItemName = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.smaller};
    font-weight: ${theme.fontWeights.medium};
  `
)

export const Group = styled.div`
  & + & {
    margin-top: 48px;
  }
`
